import "bootstrap";
import "jquery";
import "jquery-ajax-unobtrusive";
import 'jquery-ui-bundle';
import 'jquery-ui-touch-punch';

//TODO: Deze
//import "jquery-ajax-unobtrusive";

import { App } from "./App";


$("document").ready(() => {

    new App();

    $('.starthubs-header').each((index, headerElement) => {
        var header = $(headerElement);

        const active = "submenu--active";
        const li_active = "menu__item--has-children--active";

        const body = document.querySelector("html");
        const html = document.querySelector("body");
    
        const submenu = header.find(".submenu");
    
        header.find(".menu__links:not(.menu__item--has-children .menu__links), .submenu__item .menu__links").on("click", function () {
            submenu.removeClass(active);

            body.style.overflowY = "initial";
            html.style.overflowY = "initial";
        });
    
        const desktop_menu = header.find(".menu__items--desktop");
        const desktop_menu_children = desktop_menu.find(".menu__item--has-children");
        desktop_menu_children.hover(function () {
            desktop_menu_children.toggleClass(li_active);
            desktop_menu_children.find(".submenu").toggleClass(active);
        });

        const desktop_translation_menu_children = desktop_menu.find(".translation_menu__item--has-children");
        desktop_translation_menu_children.hover(function () {
            desktop_translation_menu_children.toggleClass(li_active);
            desktop_translation_menu_children.find(".submenu").toggleClass(active);
        });

    });

    $(".tabs__tab").on("click",
        function() {
            $(".tab-block--active").removeClass("tab-block--active");
            $(".tabs__tab--active").removeClass("tabs__tab--active");
            $(".tab-block[deta-tab=" + $(this).attr("deta-tab") + "]").addClass("tab-block--active");
            $(this).addClass("tabs__tab--active");
        });

    const search_title = $('.searchbar__title');
    const search_form = $('.searchbar__form');
    search_title.on("click", function(){
        if(search_form.hasClass('hidden-md-down')){
            search_form.removeClass("hidden-md-down");
        }else{
            search_form.addClass("hidden-md-down");
        }
    });
});